import '@total-typescript/ts-reset';
import { init, BrowserTracing, Replay } from '@sentry/react';
import posthog from 'posthog-js';

const setSentry = (options) => {
  const {
    env,
    dsn,
    version,
    // TODO: ask backend to add "sentry-trace" and "baggage" to CORS allowlist https://docs.sentry.io/platforms/javascript/usage/distributed-tracing/
    // tracePropagationTargets = [/^https:\/\/api\.mozio\.com/],
    tracePropagationTargets = [],
    organization,
    projectId,
    ignoreErrors
  } = options;
  if (env !== "production" && env !== "preview") {
    return;
  }
  if (!dsn) {
    console.error("Sentry DSN is not set");
    return;
  }
  init({
    dsn,
    environment: env,
    release: version,
    integrations: [
      // Performance Monitoring
      new BrowserTracing({
        // backend apis to trace https://docs.sentry.io/platforms/javascript/performance/instrumentation/automatic-instrumentation/#tracepropagationtargets
        tracePropagationTargets
      }),
      new Replay(),
      ...projectId ? [new posthog.SentryIntegration(posthog, organization, projectId)] : []
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1,
    // Session Replay: https://docs.sentry.io/platforms/javascript/session-replay/understanding-sessions/#default-session-initialization
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1,
    ignoreErrors
  });
};
const setLoggly = (options) => {
  const { env, token } = options;
  if (env !== "production") {
    return;
  }
  if (!token) {
    console.error("Loggly token is not set");
    return;
  }
  window._LTracker = window._LTracker ?? [];
  window._LTracker.push({
    logglyKey: token,
    sendConsoleErrors: true
  });
};
const createPushLoggly = (ctx) => (data) => {
  const { partnerRef, appVersion, env, appName } = ctx;
  const baseLogData = {
    source: `front-end-${appName}-${env}`,
    referrer: partnerRef,
    browser: {
      appVersion,
      language: window.navigator.language,
      userAgent: window.navigator.userAgent,
      platform: window.navigator.platform,
      appCodeName: window.navigator.appCodeName,
      hostname: window.location.hostname
    }
  };
  const completeLogObject = {
    ...data,
    ...baseLogData
  };
  if (env !== "production") {
    console.log("Loggly", completeLogObject);
    return;
  }
  if (!window._LTracker) {
    console.error("Loggly tracker is not set");
    return;
  }
  window._LTracker.push(completeLogObject);
};

export { createPushLoggly, setLoggly, setSentry };
